import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  private accessToken: string | null = null;
  constructor(private router: Router, private http: HttpClient) {}

  isAuthenticated(): boolean {
    if (sessionStorage.getItem("token") !== null) {
      return true;
    }
    return false;
  }

  canAccess() {
    if (!this.isAuthenticated()) {
      //redirect to login
      this.router.navigate(["/"]);
    }
  }
  canAuthenticate() {
    if (this.isAuthenticated()) {
      //redirect to dashboard
      this.router.navigate(["/dashboard"]);
    }
  }

  storeToken(token: string) {
    sessionStorage.setItem("token", token);
  }
  setAccessToken(token: string): void {
    sessionStorage.setItem("token", token);
  }

  login() {
    this.router.navigate(["/dashboard"]);
  }

  detail() {
    let token = sessionStorage.getItem("token");

    return this.http.post<{
      users: Array<{ localId: string; displayName: string }>;
    }>(
      "https://identitytoolkit.googleapis.com/v1/accounts:lookup?key=[API_KEY]",
      { idToken: token }
    );
  }

  getAccessToken(): string | null {
    return this.accessToken;
  }
  removeToken() {
    sessionStorage.removeItem("token");
  }
}
